<template>
	<div id="renderScene" class="fullSize" ref="rendercontainer" 

	v-touch:start="sceneTouchStart" v-touch:end="sceneTouchEnd" 

	v-touch:moved="movedHandler"
	v-touch:moving="movingHandler"
	>

		<div id="playpause" v-if="videoControlsWelcome()"
		v-on:click="playPauseVideo"
		v-bind:class="this.videoPaused ? 'paused' : null"></div>

		<div id="restartvideo" v-if="videoControlsWelcome()"
		v-on:click="restartVideo(true)"></div>

		<div id="debug" style="position:fixed; top: 50px; right: 40px; color:red; z-index:999999999999"
		>

		</div>


		<video id="videoMainTex" ref="welcomevideo" crossOrigin="anonymous" playsinline style="display:none;"
		v-on:ended="videoEnded">
			<source src="data/videos/withyoualltheway_2.mp4" type="video/mp4">
			Your browser does not support the video tag.
		</video>
	</div>
</template>

<script>
import * as THREE from 'three';
import * as Stats from "stats.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';

import DynamicTexture from '../assets/engine/dynamicTextureOb.js'

import Between from 'between.js';

/*
import balloon_vShader from 'raw-loader!../assets/shaders/balloon_vShader.vert';
import balloon_fShader from 'raw-loader!../assets/shaders/balloon_fShader.frag';
*/

import Grid from '../assets/engine/grid.js'

import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
 
Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    touchHoldTolerance: 300,
    swipeTolerance: 30,
    longTapTimeInterval: 300
})



export default {
	name: 'RenderScene',
	props: {
		App: Object
	},
	data : function() {
		return {
			clock: null,
			delta: null,

			loadingManager: null,
			fileLoader: null,
			objectLoader: null,
			RGBELoader: null,
			FBXLoader: null,
			textureLoader: null,

			easingCameraTarget : null,
			easingCameraPos : null,
			easingCameraFov: null,

			videoTex: null,
			videoMat: new THREE.MeshStandardMaterial({ color: 0x000000, side: THREE.DoubleSide, roughness:0.12 }),
			videoGroup: new THREE.Group(),
			videoMesh: null,

			sceneGroup : new THREE.Group(),

			//nodeCount: 0,
			collisionGeometry: new THREE.SphereBufferGeometry( 200 ),
			collisionGroup: new THREE.Group(),
			collisionMat: new THREE.MeshBasicMaterial( { color: 0xff0000, wireframe: true, transparent:true, opacity:0.3 } ),

			click: {
				raycaster: new THREE.Raycaster(),
				mouse: new THREE.Vector2( 0, 0 ),
				mousePrev: new THREE.Vector2( 0, 0 ),
				mouseDelta: new THREE.Vector2( 0, 0 ),
				downTime: Date.now(),
				shortClickMillis: 250,
				touching : false,
				moving : false
			},
			

			nextCameraPos: {x: 0.0, y: 220.0, z: 0.0, distance: 700, yaw: 0},

			grid: null,
			loaded: true,
			scene: null,
			renderer: null,
			camera: null,
			controls: null,
			controlsUpdating : true,
			stats: null,
			cube: null,
			metercube: null,
			metercube_mat: null,
			pmremGenerator : null,
			exrCubeRenderTarget: null,
			envMap: null,

			namesGeometry: new THREE.PlaneBufferGeometry( 450, 450, 1 , 1 ),
			namesGroup: new THREE.Group(),
			planeMeshNeedsUpdate: true,

			thumbsGeometry: new THREE.PlaneBufferGeometry( 112, 112, 1 , 1 ),
			thumbsGroup: new THREE.Group(),
			thumbsMeshNeedsUpdate: true,

			productsGroup: new THREE.Group(),

			videoPaused: false

			
			
		}
	},
	mounted() {
		this.init();
		this.animate();

		//this.setGridPlane();

		//this.setStats();
	},
	created() {
		window.addEventListener('resize', () => {this.onWindowResize()})
	},
	methods : {

		

		init() {
			this.clock = new THREE.Clock();
			this.clock.start()

			this.loadingManager = new THREE.LoadingManager();
			this.fileLoader = new THREE.FileLoader(this.loadingManager);
			this.objectLoader = new THREE.ObjectLoader(this.loadingManager);
			this.RGBELoader = new RGBELoader(this.loadingManager);
			this.FBXLoader = new FBXLoader(this.loadingManager);
			this.textureLoader = new THREE.TextureLoader(this.loadingManager);

			this.scene = new THREE.Scene(); 

			//this.scene.fog = new THREE.Fog( 0xffffff, 500, 5000 );

			this.App.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
			this.App.renderer.outputEncoding = THREE.sRGBEncoding;
			this.App.renderer.toneMapping = THREE.ACESFilmicToneMapping;
			//this.App.renderer.toneMapping = THREE.CustomToneMapping;
			this.App.renderer.toneMappingExposure  = 1.0;


			this.App.renderer.setPixelRatio( window.devicePixelRatio );
			this.App.renderer.setSize( window.innerWidth, window.innerHeight );
			
			this.App.renderer.physicallyCorrectLights = true;
			this.App.renderer.gammaFactor = 2.2;
			this.App.renderer.setClearAlpha(0.0);
			this.App.renderer.setClearColor( 0xffffff, 0.0);
			this.App.renderer.autoClear = true;

			this.camera = new THREE.PerspectiveCamera( 55, window.innerWidth / window.innerHeight, 2.0, 80000 );
			this.camera.position.set( -200, 220, -700 );


			this.controls = new OrbitControls( this.camera, this.App.renderer.domElement );
			this.controls.enableDamping = true; 
			this.controls.minDistance = 300;
			this.controls.maxDistance = 600;
			this.controls.target = new THREE.Vector3(0,220,0);
			this.controls.maxPolarAngle = Math.PI / 1.66;
			this.controls.minPolarAngle = Math.PI / 20.0;

			// envMap
			this.pmremGenerator = new THREE.PMREMGenerator( this.App.renderer );
			this.pmremGenerator.compileEquirectangularShader();

			this.loadingManager.onLoad = () => {
				this.pmremGenerator.dispose();
			}
			
			this.loadEnvMap();

			this.$refs.rendercontainer.appendChild(this.App.renderer.domElement);

			this.scene.add(this.sceneGroup);
			this.scene.add(this.videoGroup);

			this.setControlsCommands(false);
			
			

			/* events bindings */

			document.addEventListener('startAll', () => { this.startAll(); })

			document.addEventListener('playVideo', () => { this.playVideo(); })

			document.addEventListener('moveCamera', () => { this.moveCameraToNextPos(); })

			document.addEventListener('mapToggle', () => { this.toggleMapView(); })

			document.addEventListener('moveToNextNode', () => { this.moveToNextNode(); })

			document.addEventListener('moveToPrevNode', () => { this.moveToPrevNode(); })

			document.addEventListener('loader3DFinished', (e) => { this.loader3DFinished(e); })

			document.addEventListener('hashChanged', () => { this.hashChanged(); })

			document.addEventListener('displayVideoPanel', () => {

				this.$refs.welcomevideo.pause();
				this.videoPaused = true;
			})
			/*
			document.addEventListener('hideVideoPanel', () => {
				
				if(this.App.currentNode.type == 0 && !this.muted) {
					this.$refs.welcomevideo.muted = false;
				}
					
			})*/

			

		},

		videoEnded() {
			this.videoPaused = true;
			this.restartVideo(false);
		},

		playPauseVideo() {
			this.videoPaused = !this.videoPaused;

			if(this.videoPaused)
				this.$refs.welcomevideo.pause();
			else
				this.$refs.welcomevideo.play();
		},

		restartVideo(play = true) {
			

			this.$refs.welcomevideo.pause();
			
			
			if(play) {
				this.$refs.welcomevideo.currentTime = 0;
				this.$refs.welcomevideo.play();
				this.videoPaused = false;
			}
			else {
				this.$refs.welcomevideo.currentTime = 28;
				this.videoPaused = true;
			}
				
		},

		mute() {

			this.muted = !this.muted;

			this.$refs.welcomevideo.muted = this.muted;

		},

		videoControlsWelcome() {
			if(this.App.currentNode != null && this.App.currentNode.type == 0 && !this.App.viewMode.map)
				return true;
			return false;
		},

		//TODO: V2: vue router ?
		/** Triggers when the hash changes
		 * Move to corresponding node if hash corresponds to node ID
		 */
		hashChanged() {

			//var nodeId = parseInt(location.hash.replace('#', ''))
			var nodeHash = location.hash.replace('#', '')

			//if(!isNaN(nodeId)) {
			var result = this.getNodeByHash(nodeHash)

			if(result.node != null) {
				if(result.node.type != 0) {

					this.$refs.welcomevideo.pause();
					this.videoPaused = true;
				}
				/*
				else {
					if(!this.muted)
						this.$refs.welcomevideo.muted = false;
				}*/
					
				this.goToNode(result.node)
			}
			//}

		},

		checkNodeForHash(node, hash, result) {
			if(node.urlHash == hash)
				result.node = node
			else {
				node.children.forEach( (childNode) => {
					this.checkNodeForHash(childNode, hash, result)
				} )
			}
		},

		getNodeByHash(hash) {
			var result = { node: null }
			this.App.room.hierarchy.forEach((childNode) => { 
				this.checkNodeForHash(childNode, hash, result)
			})

			return result;
		},

		checkNodeForId(node, id, result) {
			if(node.id == id)
				result.node = node
			else {
				node.children.forEach( (childNode) => {
					this.checkNodeForId(childNode, id, result)
				} )
			}
		},

		getNodeById(id) {
			var result = { node: null }
			this.App.room.hierarchy.forEach((childNode) => { 
				this.checkNodeForId(childNode, id, result)
			})

			return result;
		},

		/**
		 * Fires when room.json data is loaded
		 */
		startAll() {


			//console.log('START SCENE 3D')
			this.loadScene3D();
			

			/*
			setTimeout(() => {
				this.loadTrapTest()
			}, 2500);*/
			

			//this.loadCubeDemo();

			document.fonts.ready.then( () => {
				setTimeout(() => {
					this.initCollision();

					if(this.App.startHash != "") {
						location.hash = this.App.startHash
					}
						
				}, 1000);
			});

		},

		/**
		 * Fires when the global loader 3D manager has finished his current Loading session
		 */
		loader3DFinished(e) {
			
			var loader3D = e.detail.loader3D

			if(this.App.currentNode != null && this.App.currentNode.loader3d != null && loader3D.id == this.App.currentNode.loader3d.id) {
				loader3D.loadedGroups.forEach((grouploaded) => {
					grouploaded.position.set(this.App.currentNode.focusPos.x, this.App.currentNode.focusPos.y, this.App.currentNode.focusPos.z)
					grouploaded.rotation.y = this.App.currentNode.cameraYaw * Math.PI / 180
					this.scene.add(grouploaded)
				}) 
			}
			else if(!loader3D.product) { //Auto add to scnee only if not a product
				loader3D.loadedGroups.forEach( (group) => {
					this.scene.add(group)
				})
			}

			if(this.App.currentNode != null && this.App.currentNode.thumbMesh != undefined)
				this.App.currentNode.thumbMesh.visible = false;

			

			////console.log(loader3D)

		},

		/** Loads Env map */
		loadEnvMap() {
			this.RGBELoader.setPath( 'data/textures/env/' ).setDataType( THREE.UnsignedByteType ).load('custom_01_1k.hdr', (texture) => {
				texture.magFilter = THREE.LinearFilter;
				texture.needsUpdate = true;

				
				this.envMap = this.pmremGenerator.fromEquirectangular( texture ).texture;
				this.envMap.encoding = THREE.RGBEEncoding;
				//this.scene.background = this.envMap;
				this.scene.environment = this.envMap;

				// Generate cubemap object for custom shader uniforms
				// -------------------------------------------------
				var options = {
					generateMipmaps: true,
					minFilter: THREE.LinearMipMapLinearFilter,
					magFilter: THREE.LinearFilter
				};

				var newTexHDR = texture.clone();
				texture.encoding = THREE.RGBEEncoding;
				newTexHDR.minFilter = THREE.NearestFilter;
				newTexHDR.magFilter = THREE.NearestFilter;
				newTexHDR.flipY = true;
				this.App.hdrCubeMap = new THREE.WebGLCubeRenderTarget( 32, options ).fromEquirectangularTexture( this.App.renderer, newTexHDR ).texture;
				this.App.hdrCubeMap.encoding = THREE.RGBEEncoding;
				this.App.hdrCubeMap.mapping = THREE.EquirectangularReflectionMapping;
				this.App.hdrCubeMap.needsUpdate = true;
				//this.App.hdrCubeMap.mapping = THREE.EquirectangularReflectionMapping;
				// -------------------------------------------------

				texture.dispose();
				this.pmremGenerator.dispose();


			});	
		},

		loadCubeDemo() {
			// Cube demo
			var metercube_geo = new THREE.SphereGeometry(50, 32, 32);
			this.metercube_mat = new THREE.MeshStandardMaterial( { color: 0xffffff, envMapIntensity: 1.0, roughness: 0.0, metalness: 1.0 } );
			this.metercube = new THREE.Mesh( metercube_geo, this.metercube_mat );
			this.metercube.position.set( 1100.0, 100.0, -1000.0 );
			this.scene.add( this.metercube );

			var geometry = new THREE.BoxGeometry(25, 25, 25);
			var material = new THREE.MeshStandardMaterial( { color: 0x00ff00 } );
			this.cube = new THREE.Mesh( geometry, material );
			this.cube.position.y = 50;
			this.cube.position.set(-1000.0, 120.0, -1000.0);
			this.scene.add( this.cube );

			this.objectLoader.load('data/meshes/cube_1m_test.json', (obj) => {

				obj.material = new THREE.MeshStandardMaterial({ color: 0x2c2c2c, envMapIntensity: 1.0, roughness: 0.3, metalness: 0.0 });
				
				this.scene.add(obj);
			})
		},

		loadScene3D() {

			this.App.LoadingManagerGlobal.loadSceneMeshes()

			this.FBXLoader.load('data/meshes/room/scene_minvideo.fbx', (object) => {
				this.videoMesh = object.children[0];
				this.videoGroup.add(this.videoMesh);
			}, 
			() => {
				////console.log( 'progress', (xhr.loaded / xhr.total * 100) + '% loaded' );
			})

		},

		loadTrapTest() {

			// --------------- trap 01
			// creates a new loader3D instance
			var loader3D = this.App.LoadingManagerGlobal.createLoader3D(false, false)
			// prepare objects to load 
			loader3D.prepareLoadAssetGroup( loader3D.getAssetGroupFromId(40003));
			// start the loader
			loader3D.start()

			// --------------- trap 02
			/*
			var loader3D2 = this.App.LoadingManagerGlobal.createLoader3D(false, false)	
			loader3D2.prepareLoadAssetGroup( loader3D.getAssetGroupFromId(40003));
			loader3D2.start()*/
		},

		setGridPlane() {

			this.grid = new Grid(10000, 100, 1.0, new THREE.Color( 0x2d2d2d), 0.2 );
			this.scene.add(this.grid.mesh);
			
		},

		setControlsCommands(map = false) {
			if(map) {
			
				this.controls.enableRotate = false;
				this.controls.enablePan = true;

				this.controls.mouseButtons = {
					LEFT: THREE.MOUSE.PAN,
					MIDDLE: THREE.MOUSE.DOLLY,
					RIGHT: THREE.MOUSE.ROTATE
				}

				this.controls.touches = {
					ONE: THREE.TOUCH.PAN,
					TWO: THREE.TOUCH.ROTATE
				}
			}
			else {
				
			
				this.controls.enableRotate = true;
				this.controls.enablePan = false;

				this.controls.mouseButtons = {
					LEFT: THREE.MOUSE.ROTATE,
					MIDDLE: THREE.MOUSE.DOLLY,
					RIGHT: THREE.MOUSE.PAN
				}

				this.controls.touches = {
					ONE: THREE.TOUCH.ROTATE,
					TWO: THREE.TOUCH.DOLLY_PAN
				}
			}
		},

		enableMapView() {
			//this.nodeChangeCameraUpdate(this.App.room.map.camDistanceBounds.min, this.App.room.map.camDistanceBounds.max);
			//this.App.currentNode = null;
			//this.controls.enabled = false;
			location.hash = 'map'

			this.$refs.welcomevideo.pause();
			this.videoPaused = true;

			this.App.contentPanelOpen = false
			
			

			this.controlsUpdating = false;

			this.setControlsCommands(true)

			this.App.viewMode = {
				nav: false,
				map: true,
				product: false
			}

			

			this.cameraMove(
				{x: this.App.room.map.center.x, y: this.App.room.map.center.y, z: this.App.room.map.center.z},

				{x: this.App.room.map.center.x, y: this.App.room.map.altitude, z: this.App.room.map.center.z + this.App.room.map.offsetZ},
				35,
				this.App.room.map.camDistanceBounds.min,
				this.App.room.map.camDistanceBounds.max,
				true
			)
		},

		disableMapView() {
			this.setControlsCommands(false)

			

			this.moveCameraToNextPos() 


			/*if(this.App.currentNode.type == 0) 
				this.$refs.welcomevideo.muted = false*/

			this.App.contentPanelVisible = true;
		},

		toggleMapView() {
			if(this.App.viewMode.map == false)
				this.enableMapView()
			else 
				this.disableMapView()

			this.planeMeshNeedsUpdate = true;
			
		},

		moveCameraToNextPos() {
			
			
			this.App.viewMode = {
				nav: [0,1,2].includes(this.App.currentNode.type),
				map: false,
				product: [3,4,5].includes(this.App.currentNode.type)
			}

			this.setControlsCommands(false)

			var YaWDefaultCamera =  this.nextCameraPos.yaw * (Math.PI / 180);

			var wantedCameraPos = {
				x: (Math.sin(YaWDefaultCamera) * this.nextCameraPos.distance) + this.nextCameraPos.x,
				y: this.nextCameraPos.y,
				z: (Math.cos(YaWDefaultCamera) * this.nextCameraPos.distance)  + this.nextCameraPos.z
			}

			this.cameraMove(
				{x: this.nextCameraPos.x, y: this.nextCameraPos.y, z: this.nextCameraPos.z},
				wantedCameraPos,
				55,
				this.App.currentNode.camDistanceBounds.min,
				this.App.currentNode.camDistanceBounds.max
			)

			this.planeMeshNeedsUpdate = true


		},

		cameraMove(nextTarget, nextPos, nextFov, nextZoomMin, nextZoomMax, formap = false, duration = 1000, easing = Between.Easing.Cubic.InOut) {

			this.nodeChangeCameraUpdate(0, 9999999)

			/*	-------------------------------
					Cancel current move
				------------------------------- */
			if(this.easingCameraTarget != null && this.easingCameraPos != null) {
				this.easingCameraTarget.pause();
				this.easingCameraTarget.off();
				this.easingCameraTarget = null;
			}
			if(this.easingCameraPos != null) {
				this.easingCameraPos.pause();
				this.easingCameraPos.off();
				this.easingCameraPos = null;
			}
			if(this.easingCameraFov != null) {
				this.easingCameraFov.pause();
				this.easingCameraFov.off();
				this.easingCameraFov = null;
			}


			/*	-------------------------------
					Camera target easing
				------------------------------- */
			var currentControlTarget = {
				x: this.controls.target.x,
				y: this.controls.target.y,
				z: this.controls.target.z
			}
			this.easingCameraTarget = new Between(currentControlTarget, nextTarget).time(duration)
			.easing(easing)
			.on('update', (value) => {
				this.controls.target = new THREE.Vector3(value.x,value.y,value.z);
				this.controls.update();
			});


			/*	-------------------------------
					Camera Position easing
				------------------------------- */
			var currentCamPos = {
				x: this.camera.position.x,
				y: this.camera.position.y,
				z: this.camera.position.z
			}
			this.easingCameraPos = new Between(currentCamPos, nextPos )
			.time(duration + 400)
			.easing(easing)
			.on('update', (value) => {
				this.camera.position.set(value.x,value.y,value.z );
				//this.camera.lookAt(nextPos.x, nextPos.y, nextPos.z)
				this.camera.updateProjectionMatrix();
			}).on('complete', () => {
				this.nodeChangeCameraUpdate(nextZoomMin, nextZoomMax)
				this.planeMeshNeedsUpdate = true;
			});

			/*	-------------------------------
					Camera FOV easing
				------------------------------- */
				
			this.easingCameraFov = new Between( this.camera.fov , nextFov ).time(duration)
			.easing(easing)
			.on('update', (value) => {
				this.camera.fov = value;
				this.camera.updateProjectionMatrix();
			});


			if(formap) {

				var camRot = {
					x: this.camera.rotation.x,
					y: this.camera.rotation.y,
					z: this.camera.rotation.z
				}
				this.easingCameraFov = new Between( camRot , 
				{
					//TODO: calc x rotation with target + pos + App.map.offsetZ
					//x: - (Math.PI / 2),
					x: -1.373,
					y: 0,
					z: 0
				} ).time(duration + 400)
				.easing(easing)
				.on('update', (value) => {
					this.camera.rotation.x = value.x;
					this.camera.rotation.y = value.y;
					this.camera.rotation.z = value.z;
					this.camera.updateProjectionMatrix();
				}).on('complete', () => {
					
					
						this.controlsUpdating = true;
						this.camera.position.set(nextPos.x,nextPos.y,nextPos.z)
						this.controls.target.set(nextTarget.x,nextTarget.y,nextTarget.z)

						this.planeMeshNeedsUpdate = true;

						this.App.contentPanelVisible = false;
					
					
				});
				
			}
		},

		sceneTouchStart(){
			this.click.downTime = Date.now();

			this.click.touching = true;
		},

		CLICKTEST(e) {
			//console.log('clicktest', e)
			this.sceneClick( {
				clientX : e.clientX,
				clientY : e.clientY
			});
		},

		mouseupM(e) {
			//console.log('mouse up new')
			this.sceneTouchEnd(e);
		},

		mousedownM() {
			//console.log('mouse down new')
			this.sceneTouchStart()
		},

		sceneTouchEnd(e) {
			this.click.touching = false;
			this.click.moving = false;

			this.click.mousePrev.x = this.click.mouse.x
			this.click.mousePrev.y = this.click.mouse.y
			this.click.mouseDelta = new THREE.Vector2(0,0)

			if(e.type == "mouseup")
				this.sceneUpTouchClick(e)
			else {
				this.sceneUpTouchClick( {
					clientX : e.changedTouches[0].clientX,
					clientY : e.changedTouches[0].clientY
				});
			}
			
		},

		sceneUpTouchClick(e) {

			const millis = Date.now() - this.click.downTime;
			if (millis <= this.click.shortClickMillis) {
				this.sceneClick(e);
			}
		},

		sceneClick(e) {
			this.click.mouse.x = ( e.clientX / window.innerWidth ) * 2 - 1;
			this.click.mouse.y = - ( e.clientY / window.innerHeight ) * 2 + 1;

			this.click.raycaster.setFromCamera( this.click.mouse, this.camera );

			var intersects = this.click.raycaster.intersectObjects( this.collisionGroup.children );

			if( intersects.length > 0) {
					
				var nodeClicked = intersects[0].object.node;

				// checks if clicked on current node
				if(this.App.currentNode != null && nodeClicked.id == this.App.currentNode.id && !this.App.viewMode.map) {

					// checks if click hits a node behind
					if(intersects.length > 1) {
						nodeClicked = intersects[1].object.node;
					}
					else {
						return;
					}
					
				}

				this.moveToNode(nodeClicked)

				
			}

		},

		movedHandler() {
			this.click.moving = true;
			this.click.touching = true;
		},

		movingHandler() {



			// if the user is clicking or touching the screen
			if(this.click.touching) {

				// if he is touching / clicking the screen for longer than a tap
				if(Date.now() - this.click.downTime > this.click.shortClickMillis ) {
					this.click.moving = true;
					/*

					this.click.mousePrev.x = this.click.mouse.x
					this.click.mousePrev.y = this.click.mouse.y

					if(e.type == 'mousemove') {
						this.click.mouse.x = ( e.clientX / window.innerWidth ) * 2 - 1;
						this.click.mouse.y = - ( e.clientY / window.innerHeight ) * 2 + 1;
					}
					else  {
						this.click.mouse.x = ( e.changedTouches[0].clientX / window.innerWidth ) * 2 - 1;
						this.click.mouse.y = - ( e.changedTouches[0].clientY / window.innerHeight ) * 2 + 1;
					}

					this.click.mouseDelta.x =  this.click.mousePrev.x - this.click.mouse.x
					this.click.mouseDelta.y =  this.click.mousePrev.y - this.click.mouse.y*/

				}
			}


		},

		// called in UI on naviation click
		moveToNextNode() {
			this.moveToNode(this.App.nextNode)
		},

		getParentOfCurrentNode(node, parentNodeRes) {
			node.children.forEach( (childNode) => {
				parentNodeRes.iterations++;
				if (childNode.id == this.App.currentNode.id) {
					parentNodeRes.result = node;
					return;
				}
				else {
					this.getParentOfCurrentNode(childNode, parentNodeRes);
				}
			})
		},

		getParentOfNode(node, parentNodeRes, idcheck) {
			node.children.forEach( (childNode) => {
				parentNodeRes.iterations++;
				if (childNode.id == idcheck) {
					parentNodeRes.result = node;
					return;
				}
				else {
					this.getParentOfNode(childNode, parentNodeRes, idcheck);
				}
			})
		},

		moveToPrevNode() {

			var parentNodeRes = { result: null, iterations : 0 };

			// Should always be 1 child at the beginning, so foreach is not mandatory, but anyways, ready for futur changes
			this.App.room.hierarchy.forEach((childNode) => { 
				this.getParentOfCurrentNode(childNode, parentNodeRes)
			})
			
			this.moveToNode(parentNodeRes.result)

		},

		moveToNode(nodeClicked) {

			location.hash = nodeClicked.urlHash

			

		},

		removeCurrentProduct3D() {
			if(this.App.currentNode.meshgroupid != null) {
				if(this.App.currentNode.loader3d != null) {
					this.App.currentNode.loader3d.loadedGroups.forEach((grouploaded) => {
						//grouploaded.position.set(this.App.currentNode.focusPos.x, this.App.currentNode.focusPos.y, this.App.currentNode.focusPos.z)
						this.scene.remove(grouploaded)
					}) 
				}
			}

		},

		loadCurrentProduct3d() {
			if(this.App.currentNode.meshgroupid != null) {
				if(this.App.currentNode.loader3d == null) {
					this.App.currentNode.loader3d = this.App.LoadingManagerGlobal.createLoader3D(false, true)
					this.App.currentNode.loader3d.prepareLoadAssetGroup( this.App.currentNode.loader3d.getAssetGroupFromId(this.App.currentNode.meshgroupid));
					this.App.currentNode.loader3d.start()
				}
				else {

					this.App.currentNode.loader3d.loadedGroups.forEach((grouploaded) => {
						grouploaded.position.set(this.App.currentNode.focusPos.x, this.App.currentNode.focusPos.y, this.App.currentNode.focusPos.z)
						grouploaded.rotation.y = this.App.currentNode.cameraYaw  * Math.PI / 180
						this.scene.add(grouploaded)
					}) 

					if(this.App.currentNode.thumbMesh != undefined)
						this.App.currentNode.thumbMesh.visible = false;
					
				}
				
			}
		},

		goToNode(nodeClicked) {
			this.App.contentPanelVisible = true;

			this.App.currentOvername = null;

			if(nodeClicked.type != 5) {
				this.App.relatedPanelOpen = false;
				this.prepareAndMoveToNode(nodeClicked)
			}
			else {
				
				this.App.openRelatedProduct(nodeClicked);
				console.log("openRelatedProduct")

				if(!this.App.nextLinkNoMovement) {
					var parentNodeRes = { result: null, iterations : 0 };
					this.App.room.hierarchy.forEach((childNode) => { 
						this.getParentOfNode(childNode, parentNodeRes, nodeClicked.id)
					})

					// if the related 2d product is not a child of the current ode, move to the corresponding node
					if(parentNodeRes.result.id != this.App.currentNode.id) {
						this.prepareAndMoveToNode(parentNodeRes.result)

					}
				}
				else {
					this.App.nextLinkNoMovement = false;
				}
				
					
			}

			//this.removeCurrentProduct3D()

			/*
			//Default distance table if not specified in node
			var nextDistance = nodeClicked.camDistance != null ? nodeClicked.camDistance : this.App.nodeParams.distanceDefault[nodeClicked.type];

			this.nextCameraPos = { x: nodeClicked.focusPos.x, y: nodeClicked.focusPos.y, z: nodeClicked.focusPos.z, distance: nextDistance, yaw: nodeClicked.cameraYaw }
			
			this.App.currentTitle = nodeClicked.title;

			this.App.currentNode = nodeClicked;

			

			document.dispatchEvent(this.App.events.moveCamera);

			this.App.updateContentPanel();

			this.loadCurrentProduct3d();

			
			
			
			

			if(!this.App.portrait)
				this.App.contentPanelOpen = true
				*/
		},
		prepareAndMoveToNode(node) {
			if(this.App.currentNode != null && this.App.currentNode.thumbMesh != undefined)
					this.App.currentNode.thumbMesh.visible = true;


			this.removeCurrentProduct3D()

			//Default distance table if not specified in node
			var nextDistance = node.camDistance != null ? node.camDistance : node.camDistanceBounds.min + (  (node.camDistanceBounds.max - node.camDistanceBounds.min) / 2 );

			this.nextCameraPos = { x: node.focusPos.x, y: node.focusPos.y, z: node.focusPos.z, distance: nextDistance, yaw: node.cameraYaw }
			
			this.App.currentTitle = node.title;

			this.App.currentNode = node;

			document.dispatchEvent(this.App.events.moveCamera);

			this.App.updateContentPanel();

			this.loadCurrentProduct3d();

		},
		
		nodeChangeCameraUpdate(min, max) {
			this.controls.minDistance = min;
			this.controls.maxDistance = max;

			//console.log('update bounds', max)
			
			this.updateControlsAngleClamping();

			this.controls.update();
		},

		updateControlsAngleClamping() {

			if(this.App.currentNode != null && !this.App.viewMode.map) {
				this.controls.maxPolarAngle = Math.PI - Math.acos( (this.App.currentNode.focusPos.y - 20) / this.App.currentNode.camDistanceBounds.max);
			}
			
		},

		parseNodeCollision(node, first = false) {
			
			if(first) {
				this.App.currentNode = node;
				this.App.updateContentPanel();
			}
			if(node.type != 5) {
				// -------- Setup collision sphere
				var collisionMesh = new THREE.Mesh(this.collisionGeometry, this.collisionMat);
				collisionMesh.node = node;
				node.collisionObject = collisionMesh;

				collisionMesh.position.set(node.collisionPos.x, node.collisionPos.y, node.collisionPos.z)

				collisionMesh.scale.set(1.0,1.25,1.0)

				collisionMesh.visible = this.App.debug;

				this.collisionGroup.add(collisionMesh);

				// -------- Setup text plane

				if(node.type != 0) {
					
						var dynamicTexture  = new DynamicTexture(800,800)
						//dynamicTexture.context.font	= 'bold 30px futura'; // -- old value
						dynamicTexture.context.font	= 'bold 30px futura';

						//dynamicTexture.clear('black').drawText(node.title, undefined, 256, 'white')

						// new line if two big
						dynamicTexture.clear('black').drawTextCooked(node.title, {
							lineHeight	: 0.12,
							fillStyle: 'white',
							align: 'center'
						})
						

						var nameMat = new THREE.MeshBasicMaterial( { 
							color:0x2d2d2d, 
							side: THREE.FrontSide,
							transparent: true,
							alphaMap: dynamicTexture.texture,
							depthWrite: false
						} );
						var nameMesh = new THREE.Mesh(this.namesGeometry, nameMat);
						nameMesh.position.set(node.focusPos.x, node.focusPos.y - 50, node.focusPos.z)
						nameMesh.node = node
						node.planeMesh = nameMesh
						this.namesGroup.add(nameMesh)
						dynamicTexture.texture.needsUpdate  = true

						var mapthumb = this.textureLoader.load(node.image)
						mapthumb.encoding = THREE.sRGBEncoding;
						var thumbMat = new THREE.MeshBasicMaterial( { 
							map: mapthumb, 
							side: THREE.FrontSide,
							transparent: true,
							depthWrite: false,
							toneMapped: false
						} );
						var thumbMesh = new THREE.Mesh(this.thumbsGeometry, thumbMat);
						thumbMesh.position.set(node.focusPos.x, node.focusPos.y, node.focusPos.z)
						thumbMat.node = node
						node.thumbMesh = thumbMesh
						this.thumbsGroup.add(thumbMesh)

					
				}
			}

			node.children.forEach( (child) => {
				this.parseNodeCollision(child);
			})
		},

		initCollision() {

			this.scene.add(this.collisionGroup);
			this.scene.add(this.namesGroup)
			this.scene.add(this.thumbsGroup)

			this.App.room.hierarchy.forEach( (node) => {
				this.parseNodeCollision( node, true);
			})
			this.planeMeshNeedsUpdate = true;
			this.thumbsMeshNeedsUpdate = true;
			//this.scene.add(this.collisionMesh)
		},

		playVideo() {
			var video = document.getElementById( 'videoMainTex' );
			if(this.App.startHash == "") {
				video.play();
			}

			this.videoTex = new THREE.VideoTexture( video );
			this.videoTex.minFilter = THREE.LinearFilter;
			this.videoTex.magFilter = THREE.LinearFilter;
			this.videoTex.format = THREE.RGBFormat;
			this.videoTex.encoding = THREE.sRGBEncoding;
			this.videoTex.needsUpdate = true;

			this.videoMat = new THREE.MeshStandardMaterial({ 
				color: 0x000000, 
				emissive: 0xffffff,
				emissiveMap : this.videoTex,
				side: THREE.DoubleSide,
				roughness: 0.1,
				metalness: 0.98,
				emissiveIntensity : 1.2,
				//transparent: true,
				//opacity:0.9,
				//alphaTest: 0.0,
				//depthTest: true,
				//depthWrite: true,
			})
			this.videoMat.needsUpdate = true
			if(this.videoMesh != null) {
				this.videoMesh.needsUpdate = true
				this.videoMesh.material = this.videoMat;
			}
			
		},

		setStats() {
			this.stats = new Stats();
			this.stats.dom.classList.add("statsCont", "touch");
			this.stats.dom.style.top = '100px'
			this.$refs.rendercontainer.appendChild( this.stats.dom );
		},

		onWindowResize() {
			var width = window.innerWidth;
			var height = window.innerHeight;

			//var dpr = this.App.renderer.getPixelRatio();

			this.camera.aspect = width / height;
			this.camera.updateProjectionMatrix();

			this.App.renderer.setSize( width, height );

			if(window.innerWidth < window.innerHeight)
				this.App.portrait = true
		},

		animate() {
			requestAnimationFrame( this.animate );

			////console.log(this.clock.getDelta())

			if(this.videoMesh != null) {

				this.videoGroup.rotation.y = this.controls.getAzimuthalAngle();

			}			

			// If not on map view: set the next two nodes to display name and face camera
			//TODO: display prev node with dim color ?
			if(!this.App.viewMode.map && this.App.currentNode != null) {

				////console.log(this.App.currentNode)

				if(this.planeMeshNeedsUpdate) {
					this.namesGroup.children.forEach( (planeMesh) => {
						planeMesh.visible = false;
					})

					this.collisionGroup.children.forEach( (collisionMesh) => {
						collisionMesh.scale.set(1.0,1.25,1.0)
					})
				}
				

				this.App.currentNode.children.forEach( (childNode) => {
					if(childNode.type != 5)
						this.displayNodeNameByState(childNode.planeMesh, false)
					
					
				})
				this.planeMeshNeedsUpdate = false;
				/*
				if(this.App.prevNode != null)
					this.displayNodeNameForGround(this.App.prevNode.planeMesh)
				*/
			}
			else if(this.App.viewMode.map  && this.App.currentNode != null) {
				if(this.planeMeshNeedsUpdate) {
					this.namesGroup.children.forEach( (planeMesh) => {
						this.displayNodeNameByState(planeMesh, true)
					})

					this.collisionGroup.children.forEach( (collisionMesh) => {
						collisionMesh.scale.set(1.6,1.25,1.6)
					})
					this.planeMeshNeedsUpdate = false;
				}
				
			}

			if(this.thumbsMeshNeedsUpdate) {
				this.thumbsGroup.children.forEach( (thumbMesh) => {
					thumbMesh.lookAt( this.camera.position)
				})
			}
			
			if(this.cube != null) {
				this.cube.rotation.x += 0.01;
				this.cube.rotation.y += 0.01;
			}
			

			

			this.render();

		},

		/**
		 * Displays the name planes above nodes, depends on viewmode (map ?)
		 */
		displayNodeNameByState(planeMesh, map) {

			if(map) {

				planeMesh.visible = true

				planeMesh.rotation.x = - Math.PI / 2;
				planeMesh.rotation.y = 0;
				planeMesh.rotation.z = 0;

				planeMesh.scale.set(3.0,3.0,3.0)
				planeMesh.position.set(planeMesh.node.focusPos.x, planeMesh.node.focusPos.y + 50, planeMesh.node.focusPos.z + 120)
				planeMesh.material.depthTest = false;
			}
			else {
				if(this.planeMeshNeedsUpdate) {
					planeMesh.visible = true;
					planeMesh.position.set(planeMesh.node.focusPos.x, planeMesh.node.focusPos.y - 50, planeMesh.node.focusPos.z)
					planeMesh.scale.set(1.5,1.5,1.5)
					planeMesh.material.depthTest = true;
				}

				planeMesh.lookAt( this.camera.position)
			}
			
		},

		render() {

			if(this.loaded) {
				if(this.stats != null) {
					this.stats.update();
				}
				
				if(this.controlsUpdating)
					this.controls.update();

				this.App.renderer.render( this.scene, this.camera );
			}

		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
